module.exports = __webpack_public_path__ + "img/Phone3.25a12a60.png";